import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { PaymentService } from '../../../services/payment.service';
import { Transaction } from '../../models/payment/transaction';
import { SharedModule } from '../../shared.module';
import { AddCompanyComponent } from '../upsert-company/add-company/add-company.component';
import { EditCompanyComponent } from '../upsert-company/edit-company/edit-company.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { transactionsTableConfig } from './core/transactions-table-config';
import { CommonService } from '../../../services/common.service';
import { finalize } from 'rxjs';
import { PaymentStatus } from '../../models/payment/payment-status';
import { PaymentStatusTextComponent } from '../payment-status-text/payment-status-text.component';
import * as dayjs from 'dayjs';

@Component({
  selector: 'psc-transactions-table',
  standalone: true,
  imports: [CommonModule, TranslocoModule, SharedModule, AddCompanyComponent, EditCompanyComponent, NgxDatatableModule, PaymentStatusTextComponent],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'pricing', alias: 'pricing' } }],
  templateUrl: './transactions-table.component.html',
})
export class TransactionsTableComponent implements OnInit {
  @Input() showPlantName = false;

  @Input() transactions: Transaction[];
  columns = transactionsTableConfig.columns;

  loadingTransactionBill: { [key: string]: boolean } = {};

  constructor(
    private paymentService: PaymentService,
    private commonService: CommonService,
  ) {
  }

  ngOnInit(): void {
    if (!this.transactions) {
      this.paymentService.getTransactions()
        .subscribe((transactions) => {
          this.transactions = transactions;
        });
    }
  }


  downloadBill(paymentId: string, dateOfDelivery: Date) {
    this.loadingTransactionBill[paymentId] = true;
    this.paymentService.getBill(paymentId)
      .pipe(finalize(() => {
        this.loadingTransactionBill[paymentId] = false;
      }))
      .subscribe((blob) => {
        this.commonService.downloadFile(blob, `PVSmartClick_${ dayjs(dateOfDelivery).format('YYYY-DD-MM_HH-mm') }.pdf`);
      });
  }

  protected readonly PaymentStatus = PaymentStatus;
}
